module.exports = __webpack_public_path__ + "img/company_logo3.b78a5ebd.jpg";